export const skillingSheetDropdownOptions = [
  '1',
  'TNC',
  'DNS',
  'DC',
  'WTM',
  'AN',
];

export const uaSkills = [
  'ca',
  'co',
  'ct',
  'fl',
  'ga',
  'in',
  'ky',
  'li',
  'mi',
  'mn',
  'mo',
  'ms',
  'nc',
  'ne',
  'nj',
  'ny',
  'ri',
  'sc',
  'sd',
  'tx',
  'wa',
  'wi'
];
